import * as ActionTypes from "./ActionTypes";
import {ApiManager} from "../api/ApiManager";
import DoctorProfile from "../models/IDoctorProfile"
import {AccountDataActions} from "./AccountDataActions";
import ISearchDoctor from "../models/ISearchDoctor";
import AppUtils from "../utils/AppUtils";


export class DoctorProfileActions {

    static fetchDoctorProfileSuccess(doctorProfile: any) {
        return {type: ActionTypes.FETCH_DOC_PROFILE_SUCCESS, doctorProfile : doctorProfile};
    }

    static updateDoctorProfileActionSuccess(doctorProfile: DoctorProfile) {
        return {type: ActionTypes.UPDATE_DOC_PROFILE_SUCCESS, doctorProfile : doctorProfile};
    }

    static fetchDoctorProfile(dispatch: any, searchParams: ISearchDoctor ) {
        return ApiManager.getAlbusApis().getDoctorProfile(searchParams)
            .then((response: any) => response.content)
            .then( (doctorProfiles: DoctorProfile[]) => {
                dispatch(DoctorProfileActions.fetchDoctorProfileSuccess(doctorProfiles[0]));

                // TODO: This is a hack, remove this
                if (doctorProfiles && doctorProfiles.length) {
                    dispatch({type: ActionTypes.UPDATE_USER_ID, userId: doctorProfiles[0].id})
                } else {
                    AppUtils.logout();
                }
            }).catch(error => {
                throw (error);
            });
    };

    static updateDoctorProfile (dispatch: any, doctorProfile: DoctorProfile) {
        return ApiManager.getAlbusApis().saveDoctor(doctorProfile).then((doctorProfile: DoctorProfile) => {   // This response "labPartners" is expected to have a array with single element, i.e. the saved lab partner.
            dispatch(DoctorProfileActions.updateDoctorProfileActionSuccess(doctorProfile));
        }).catch(error => {
            throw (error);
        })
    };

    static setDoctorProfile(dispatch: any, doctorProfile: DoctorProfile) {
        dispatch(DoctorProfileActions.fetchDoctorProfileSuccess(doctorProfile));

        // TODO: This is a hack, remove this
        if (doctorProfile && doctorProfile.id) {
            dispatch({type: ActionTypes.UPDATE_USER_ID, userId: doctorProfile.id})
        } else {
            AppUtils.logout();
        }
    }

    // static getAllDoctors(dispatch: any, searchParams: ISearchDoctor) {
    //     return ApiManager.getAlbusApis().getDoctorProfile(searchParams)
    //         .then((response: any) => response.content)
    //         .then( (doctorProfiles: DoctorProfile[]) => {
    //             dispatch(DoctorProfileActions.fetchDoctorProfileSuccess(doctorProfiles[0]));
    //
    //             // TODO: This is a hack, remove this
    //             if (doctorProfiles && doctorProfiles.length) {
    //                 dispatch({type: ActionTypes.UPDATE_USER_ID, userId: doctorProfiles[0].id})
    //             } else {
    //                 AppUtils.logout();
    //             }
    //         }).catch(error => {
    //             throw (error);
    //         });
    // }

}
